import { START_SAVE_LOADING, STOP_SAVE_LOADING } from "../constants";

export const startSaveLoading = () => ({
	type: START_SAVE_LOADING,
});

export const stopSaveLoading = () => ({
	type: STOP_SAVE_LOADING,
});
